import { render, staticRenderFns } from "./bulkReboot.vue?vue&type=template&id=ed20acc2&"
import script from "./bulkReboot.vue?vue&type=script&lang=js&"
export * from "./bulkReboot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports